import React from "react";
import "./Green_btn.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postCart } from "../../../../features/cart/cartSlice";

function Green_btn({
  btnText,
  onClick,
  addtext,
  product,
  quantity,
  selectedVariant,
  type,
  disabled = false,
}) {
  return (
    <>
      <section className="Green_btn_holder">
        <Button
          className="Green_btn"
          onClick={onClick}
          disabled={disabled}
          type={type ? type : "button"}
        >
          <span>{addtext}</span>
          {btnText}
        </Button>
      </section>
    </>
  );
}

export default Green_btn;
